import { AfterContentInit, Component, ContentChildren, Input, NgModule, QueryList, TemplateRef } from '@angular/core';
import { AppBaseModule } from '../../modules/app-base.module';
import { SaraPlusFormModule } from '@sp-forms/saraplus-ngx-forms';
import { AppLayoutModule } from '../../modules/app-layout/app-layout.module';
import { PrimeTemplate } from 'primeng/api';

@Component({
    selector: 'app-icon-wrapper',
    templateUrl: './icon-wrapper.component.html',
    styleUrl: './icon-wrapper.component.scss',
    standalone: false
})
export class IconWrapperComponent implements AfterContentInit {

  @ContentChildren(PrimeTemplate) templates: QueryList<PrimeTemplate> | undefined;
  @Input() iconPosition: 'right' | 'left' = 'right';
  @Input() iconStyleClass: string | undefined;
  iconTemplate: TemplateRef<any> | undefined;

  ngAfterContentInit(): void {
    this.mapTemplates();
  }

  mapTemplates() {
    if (this.templates) {
      (this.templates as QueryList<PrimeTemplate>).forEach(item => {
        switch (item.getType()) {
          case 'icon':
            this.iconTemplate = item.template;
            break;
        }
      });
    }
  }
}


@NgModule({
  declarations: [
    IconWrapperComponent
  ],
  imports: [
    AppBaseModule,
    SaraPlusFormModule,
    AppLayoutModule
  ],
  exports: [
    IconWrapperComponent
  ]
})
export class IconWrapperModule {

}